import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import DistrictCell from "./Components/DistrictCell";
import YesNoCell from "./Components/YesNoCell";

const StickyTop = styled.div`
  position: sticky;
  top: 192px;
  padding-top: 14px;
  background: white;
  border-bottom: 1px solid #d6d6d6;

  @media screen and (min-width: 540px) {
    top: 210px;
    padding-top: 20px;
    max-width: 580px;
  }
`;

const CollapseTitle = styled.div`
  width: fit-content;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 2px;

  @media screen and (min-width: 540px) {
    font-size: 18px;
  }
`;

const CaretWrapper = styled.span`
  padding-right: 14px;
`;

const ColumnHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 300;
  line-height: 28px;

  @media screen and (min-width: 540px) {
    font-size: 18px;
    line-height: 32px;
    max-width: 580px;
  }
`;

const DistrictRow = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  font-weight: 300;
  border-bottom: ${(props) =>
    props.$isLast ? "" : "1px solid rgba(0, 0, 0, 0.07)"};

  @media screen and (min-width: 540px) {
    max-width: 580px;
  }
`;

const StickyBottom = styled.div`
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #d6d6d6;
  display: flex;
  justify-content: space-between;
  font-weight: 300;
  line-height: 38px;

  @media screen and (min-width: 540px) {
    max-width: 580px;
    font-size: 18px;
  }
`;

const Bold = styled.span`
  font-weight: 500;
`;

const ExpandedChamber = ({ label, count, data, onCollapse }) => {
  const rows = [];
  for (let i = 1; i <= count; i++) {
    const d = data?.[i.toString()] ?? { YES: 0, NO: 0 };
    rows.push(
      <DistrictRow key={i} $isLast={i === count}>
        <DistrictCell>{i}</DistrictCell>
        <YesNoCell>{d.YES.toLocaleString()}</YesNoCell>
        <YesNoCell>{d.NO.toLocaleString()}</YesNoCell>
      </DistrictRow>,
    );
  }

  return (
    <>
      <StickyTop>
        <CollapseTitle onClick={onCollapse}>
          <CaretWrapper>
            <FontAwesomeIcon icon={faCaretDown} />
          </CaretWrapper>
          {label}
        </CollapseTitle>
        <ColumnHeader>
          <DistrictCell>District</DistrictCell>
          <YesNoCell>Support</YesNoCell>
          <YesNoCell>Oppose</YesNoCell>
        </ColumnHeader>
      </StickyTop>
      {rows}
      <StickyBottom>
        <DistrictCell>
          <Bold>Total</Bold>
        </DistrictCell>
        <YesNoCell>{data?.TOTAL?.YES?.toLocaleString()}</YesNoCell>
        <YesNoCell>{data?.TOTAL?.NO?.toLocaleString()}</YesNoCell>
      </StickyBottom>
    </>
  );
};

ExpandedChamber.propTypes = {
  label: PropTypes.string,
  count: PropTypes.number,
  data: PropTypes.object,
  onCollapse: PropTypes.func,
};

export default ExpandedChamber;
